export default "__VITE_ASSET__ARuaoAZB__"